import axios from 'axios';

export const switchMandantHandler = mandantId =>
	axios.post("../json/evoAppsUserInfoDialogController/switch-alternative-mandant", mandantId, {
		headers: {
			'Content-Type': 'text/plain',
		},
	}).then(
		(response) => {
			setTimeout(
				() => {
					window.location.replace(response.data);
					//ie does not reload if the location replaced is the same as currently active
					window.location.reload(); // reload manually if not already loading redirected page
				}, 500)
		},
	).catch(function () {
		alert("Fehler beim Übertragen der Daten. Bitte laden Sie die Seite erneut.");
	});
